// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.QuietTimeSelection_component__6bsy9 {
  display: flex;
  width: 100%;
  align-items: center;
}

.QuietTimeSelection_socket-selector-box__J6eVg {
  margin-bottom: 1rem;
}

.QuietTimeSelection_weekday-selector-box__eSEJt {
  flex: 1 1;
  padding-top: 1rem;
}

.QuietTimeSelection_small-weekday-box__fUJ9T {
  padding: 1rem 4rem 0rem 4rem;
}
@media screen and (max-width: 400px) {
  .QuietTimeSelection_small-weekday-box__fUJ9T {
    padding: 1rem 0px 0px 0px;
  }
}

.QuietTimeSelection_time-range-selector-box__Z8NTm {
  margin-top: 1rem;
}

.QuietTimeSelection_time-range-selection__aLcyN {
  display: flex;
  align-items: center;
}
.QuietTimeSelection_time-range-selection__aLcyN label {
  margin: 0px;
  width: 4rem;
  text-align: center;
}

.QuietTimeSelection_delete-side__iaraB {
  height: 5.5rem;
  width: 4.5rem;
  color: white;
  background: none;
  margin-left: 1rem;
  border-left: 1px solid lightgray;
}
@media screen and (max-width: 500px) {
  .QuietTimeSelection_delete-side__iaraB {
    display: none;
  }
}
.QuietTimeSelection_delete-side__iaraB img {
  width: 3rem;
  height: 3rem;
}

.QuietTimeSelection_delete-bottom__g4-b6 {
  width: 100%;
  height: 3rem;
  margin-top: 1rem;
}
@media screen and (min-width: 501px) {
  .QuietTimeSelection_delete-bottom__g4-b6 {
    display: none;
  }
}
.QuietTimeSelection_delete-bottom__g4-b6 img {
  width: 2rem;
  height: 2rem;
  margin-right: 0.5rem;
}

.QuietTimeSelection_selector-box__ae0fP {
  flex: 1 1;
}`, "",{"version":3,"sources":["webpack://./src/components/NodeInfo/QuietTimeSelection.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,WAAA;EACA,mBAAA;AACF;;AAEA;EACE,mBAAA;AACF;;AAEA;EACE,SAAA;EACA,iBAAA;AACF;;AAGA;EACE,4BAAA;AAAF;AAEE;EAHF;IAII,yBAAA;EACF;AACF;;AAEA;EACE,gBAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;AACF;AACE;EACE,WAAA;EACA,WAAA;EACA,kBAAA;AACJ;;AAIA;EACE,cAAA;EACA,aAAA;EACA,YAAA;EACA,gBAAA;EACA,iBAAA;EACA,gCAAA;AADF;AAGE;EARF;IASI,aAAA;EAAF;AACF;AAEE;EACE,WAAA;EACA,YAAA;AAAJ;;AAIA;EACE,WAAA;EACA,YAAA;EACA,gBAAA;AADF;AAGE;EALF;IAMI,aAAA;EAAF;AACF;AACE;EACE,WAAA;EACA,YAAA;EACA,oBAAA;AACJ;;AAGA;EACE,SAAA;AAAF","sourcesContent":[".component {\n  display: flex;\n  width: 100%;\n  align-items: center;\n}\n\n.socket-selector-box {\n  margin-bottom: 1rem;\n}\n\n.weekday-selector-box {\n  flex: 1;\n  padding-top: 1rem;\n}\n\n.small-weekday-box {\n  padding: 1rem 4rem 0rem 4rem;\n}\n@media screen and (max-width: 400px) {\n  .small-weekday-box {\n    padding: 1rem 0px 0px 0px;\n  }\n}\n\n.time-range-selector-box {\n  margin-top: 1rem;\n}\n\n.time-range-selection {\n  display: flex;\n  align-items: center;\n}\n.time-range-selection label {\n  margin: 0px;\n  width: 4rem;\n  text-align: center;\n}\n\n.delete-side {\n  height: 5.5rem;\n  width: 4.5rem;\n  color: white;\n  background: none;\n  margin-left: 1rem;\n  border-left: 1px solid lightgray;\n}\n@media screen and (max-width: 500px) {\n  .delete-side {\n    display: none;\n  }\n}\n.delete-side img {\n  width: 3rem;\n  height: 3rem;\n}\n\n.delete-bottom {\n  width: 100%;\n  height: 3rem;\n  margin-top: 1rem;\n}\n@media screen and (min-width: 501px) {\n  .delete-bottom {\n    display: none;\n  }\n}\n.delete-bottom img {\n  width: 2rem;\n  height: 2rem;\n  margin-right: 0.5rem;\n}\n\n.selector-box {\n  flex: 1;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"component": `QuietTimeSelection_component__6bsy9`,
	"socket-selector-box": `QuietTimeSelection_socket-selector-box__J6eVg`,
	"weekday-selector-box": `QuietTimeSelection_weekday-selector-box__eSEJt`,
	"small-weekday-box": `QuietTimeSelection_small-weekday-box__fUJ9T`,
	"time-range-selector-box": `QuietTimeSelection_time-range-selector-box__Z8NTm`,
	"time-range-selection": `QuietTimeSelection_time-range-selection__aLcyN`,
	"delete-side": `QuietTimeSelection_delete-side__iaraB`,
	"delete-bottom": `QuietTimeSelection_delete-bottom__g4-b6`,
	"selector-box": `QuietTimeSelection_selector-box__ae0fP`
};
export default ___CSS_LOADER_EXPORT___;
